/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-04-16 15:21:49
 */
export default [
  {
    path: '/auditList',
    name: '数据可视化',
    hidden: true,
    meta: {
      title: '打卡照片审核',
      icon: '',
      nav: 'act',
      level: 1
    },
    component: resolve => require(['@/views/Application.vue'], resolve),
    children: [
      {
        path: '/auditList',
        name: 'auditList',
        hidden: false,
        meta: {
          title: '打卡照片审核',
          level: 1,
          nav: 'act',
          icon: ''
        },
        component: resolve => require(['@/views/audit'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/router-audit.js